<template>
  <div class="homepage-header-pc-swiper_content">
    <no-ssr>
      <van-swipe :autoplay="5000" :duration="400" indicator-color="white">
        <van-swipe-item v-for="(item, index) in imgList" :key="index">
          <nuxt-link
            :to="`/company/${companyId}/promotion/${item.targetId}`"
            append
          >
            <div class="mobile-swipe_showImg">
              <img :src="item.url" />
            </div>
          </nuxt-link>
        </van-swipe-item>
      </van-swipe>
    </no-ssr>
  </div>
</template>

<script>
export default {
  props: {
    companyId: {
      type: [String, Number],
      default: ''
    },
    imgList: {
      type: Array,
      default: () => []
    }
  },
  methods: {}
}
</script>

<style lang="scss">
.homepage-header-pc-swiper_content {
  background: rgba(239, 241, 242, 1);
  .van-swipe {
    text-align: center;
    .mobile-swipe_showImg {
      width: 100%;
      height: calc(100vw * 9 / 16);
      flex-basis: 60%;
      img {
        width: 100%;
        height: calc(100vw * 9 / 16);
        object-fit: cover;
      }
    }
  }
}
</style>
